import { useT } from "@/i18n/LanguageContext";

/**
 * AdminLangToggle — compact EN | NL switch used inside AdminShell.
 * Reuses the app-wide LanguageProvider so switching in the admin instantly
 * updates every public-site tab too (and persists via localStorage).
 */
export default function AdminLangToggle({ testId = "admin-lang-toggle" }) {
  const { lang, setLang } = useT();
  const btn = (code, label) => (
    <button
      key={code}
      type="button"
      onClick={() => setLang(code)}
      data-testid={`${testId}-${code}`}
      aria-pressed={lang === code}
      className={`px-2 py-1 text-[10px] tracking-[0.28em] uppercase transition-colors ${
        lang === code ? "text-gold" : "text-bone/50 hover:text-gold"
      }`}
    >
      {label}
    </button>
  );
  return (
    <div
      data-testid={testId}
      className="inline-flex items-center border border-white/10 divide-x divide-white/10"
    >
      {btn("en", "EN")}
      {btn("nl", "NL")}
    </div>
  );
}
